import axios from 'axios';
import { validTokenExists } from '../firebaseHelper';

export const showSearchIdentity = (show) => (
    show.source?.id ? { sourceId: show.source.id } : {
        ...(show.appleCollectionId ? { appleCollectionId: String(show.appleCollectionId) } : {}),
        ...(show.rssURL ? { rssURL: show.rssURL } : {}),
    }
);

export const showSearchKey = (show) => (
    show.source?.id ? `source:${show.source.id}` : show.key
);

export const showSearchAliases = (show) => [...new Set([
    showSearchKey(show), show.key,
    show.appleCollectionId ? `apple:${show.appleCollectionId}` : null,
    show.rssURL ? `rss:${show.rssURL}` : null,
].filter(Boolean))];

export const showMutationFor = (mutations, show) => {
    const matches = showSearchAliases(show).map((key) => mutations[key]).filter(Boolean);
    return matches.find((mutation) => mutation.saving) || matches[0];
};

export const showPreferenceStatus = (status, mutation) => (
    mutation ? (mutation.saving ? mutation.status : mutation.previousStatus) : status
);

export const searchShows = async (query, signal) => {
    await validTokenExists();
    const { data } = await axios.post('/search_shows', { query }, { signal });
    if (!Array.isArray(data?.shows)) {
        throw new Error('Unable to load shows.');
    }
    return data.shows;
};

export const saveShowStatus = async (show, subscribeStatus, canSave = () => true) => {
    await validTokenExists();
    if (!canSave()) throw new Error('Your account changed. Please try again.');
    const { data } = await axios.post('/set_show_status', {
        show: showSearchIdentity(show),
        subscribeStatus,
    });
    if (!data?.source?.id || data.subscribeId !== data.source.id ||
        ![true, false, null].includes(data.subscribeStatus)) {
        throw new Error('Unable to save this show.');
    }
    return data;
};
